import type { BrMapping } from '@bloomreach/vue-sdk'
import Header from '@/cms-ui/components/Header/Header.vue'
import Footer from '@/cms-ui/components/Footer/Footer.vue'
import TitleBlock from '@/cms-ui/components/TitleBlock/TitleBlock.vue'
import SectionWrapper from '@/cms-ui/components/SectionWrapper/SectionWrapper.vue'
import RichContentBlock from '@/cms-ui/components/RichContentBlock/RichContentBlock.vue'
import BannersList from '@/cms-ui/components/BannersList/BannersList.vue'
import CardsList from '@/cms-ui/components/CardsList/CardsList.vue'
import HtmlContainer from '@/cms-ui/components/HtmlContainer/HtmlContainer.vue'
import Legal from '@/cms-ui/components/Legal/Legal.vue'
import FaqAndDocs from '@/cms-ui/components/FaqAndDocs/FaqAndDocs.vue'
import HeroBanner from '@/cms-ui/components/HeroBanner/HeroBanner.vue'
import Steps from '@/cms-ui/components/Steps/Steps.vue'
import Tabs from '@/cms-ui/components/Tabs/Tabs.vue'
import LeadForm from '@/cms-ui/components/LeadForm/LeadForm.vue'
import ProductList from '@/cms-ui/components/ProductList/ProductList.vue'
import {
    PlushBlogAuthorPage,
    PlushBlogBloglist,
    PlushBlogBlogpost,
    PlushBlogBreadcrumbs,
    PlushBlogNewsletter,
    PlushBlogRecommendedArticles,
    PlushBlogSwitcher,
    PlushBlogTagPage,
    ProductsGrid,
    VoiceOffersServicePlaceholder,
} from '#components'

export const plushComponents: BrMapping = {
    Header,
    Footer,
    TitleBlock,
    SectionWrapper,
    LeadForm,
    ProductsGrid,
    RichContentBlock,
    BannersList,
    CardsList,
    HtmlContainer,
    FaqAndDocs,
    Legal,
    HeroBanner,
    Steps,
    Tabs,
    ProductList,
    // eshop's placeholders
    VoiceOffersService: VoiceOffersServicePlaceholder,
    // plush blog
    BlogSwitcher: PlushBlogSwitcher,
    RecommendedArticles: PlushBlogRecommendedArticles,
    Bloglist: PlushBlogBloglist,
    Newsletter: PlushBlogNewsletter,
    Blogpost: PlushBlogBlogpost,
    Breadcrumbs: PlushBlogBreadcrumbs,
    Author: PlushBlogAuthorPage,
    Tag: PlushBlogTagPage,
}
